import {Component, OnInit, Input } from '@angular/core';
import { LabelModel } from '../label.model';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-label-result',
    templateUrl: './label-result.component.html',
    styleUrls: ['./label-result.component.scss']
})
export class LabelResultComponent extends AbstractWorkflowResultComponent<LabelModel> {
}